import type * as React from "react";
import GLTextField from "../GLTextField";
import { dateOfBirthTooltip } from "../userInfoTooltips";
import {
  getMemberDobHtmlInputBounds,
  validateMemberDobMinAge
} from "../memberDobValidation";

export { validateMemberDobMinAge } from "../memberDobValidation";

export interface GLAgePickerProps {
  id?: string;
  label?: string;
  tooltip?: string | React.ReactNode;
  value: string;
  disabled?: boolean;
  onChange?: (data: {
    e: React.ChangeEvent<HTMLInputElement>;
    isInvalid: boolean;
  }) => void;
  required?: boolean;
}

const GLAgePicker: React.FC<GLAgePickerProps> = ({
  id = "dob",
  label = "Date of Birth",
  tooltip = dateOfBirthTooltip,
  value,
  disabled = false,
  onChange,
  required = true
}) => {
  if (disabled) {
    return (
      <GLTextField
        disabled
        required={required}
        id={id}
        label={label}
        value={value}
        tooltip={tooltip}
      />
    );
  }

  if (!onChange) {
    return null;
  }

  return (
    <GLTextField
      required={required}
      id={id}
      type="date"
      label={label}
      value={value}
      onChange={onChange}
      additionalValidation={validateMemberDobMinAge}
      inputProps={getMemberDobHtmlInputBounds()}
    />
  );
};

export default GLAgePicker;
